"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ischia": {
    "1d7dac96": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "campagnano": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7b9659b9": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "ischia-ponte": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b85bf0c2": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "ischia-porto": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a0eb193": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "nuclei-principali-ischia-porto": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e7fe5e85": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "san-michele": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0fdef71f": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "skipSearch": false
    }],
    "sant-antuono": [{
      "hkey": "2c2499ee",
      "slug": "ischia",
      "name": "Ischia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;